/* eslint-disable import/no-anonymous-default-export */
export default {
    "auth": {
        'login': '/admin/auth/login',
        'logout': '/admin/auth/logout'
    },
    'banner':{
        'create': '/admin/banners',
        'update': '/admin/banners',
        'delete': '/admin/banners',
        'getDetail': '/admin/banners',
        'list': '/admin/banners',
    },
    'operator':{
        'create': '/admin/dashboard-users',
        'update': '/admin/dashboard-users',
        'delete': '/admin/dashboard-users',
        'getDetail': '/admin/dashboard-users',
        'list': '/admin/dashboard-users',
    },
    'artist_type': {
        'create': '/admin/artist-types',
        'update': '/admin/artist-types',
        'delete': '/admin/artist-types',
        'detail': '/admin/artist-types',
        'list': '/admin/artist-types',
        'all_list': '/admin/artist-types/all'
    },
    'artists': {
        'create': '/admin/artists',
        'update': '/admin/artists',
        'delete': '/admin/artists',
        'detail': '/admin/artists',
        'list': '/admin/artists',
        'filter':'/admin/artists/getArtisttype'
    },
    'category': {
        'create': '/admin/categories',
        'update': '/admin/categories',
        'delete': '/admin/categories',
        'detail': '/admin/categories',
        'list': '/admin/categories',
        'all_list' : '/admin/categories/all'
    },
    'product' : {
        'create': '/admin/products',
        'update': '/admin/products',
        'delete': '/admin/products',
        'detail': '/admin/products',
        'list': '/admin/products',
        'filter' : '/admin/products'
    },
    'process': {
        'create': '/admin/processes',
        'update': '/admin/processes',
        'delete': '/admin/processes',
        'detail': '/admin/processes',
        'list': '/admin/processes',
        'filter': '/admin/processes',
        'create_by_product': '/admin/processes/create-by-product'

    },
    'user': {
        'list': '/admin/users',
    },
    'dashboard' : {
        'list' : '/admin/dashboard/list'
    }
}